<template>
    <b-card title="Faturas">
        <div v-if="invoices.length === 0" class="d-flex justify-content-center align-items-center py-3">
            Nenhum Pagamento Encontrado
        </div>
        <b-table :items='invoices' :fields="fields">
            <template #cell(created_at)="data">
                <span>{{ $moment.unix(data.item.created).format('DD/MM/YYYY') }}</span>
            </template>
            <template #cell(total)="data">
                <span v-if="data.value">R${{ Number(data.value/100).toLocaleString('pt-BR') }}</span>
            </template>
            
            <template #cell(status)="data">
                <span :class="'text-'+ statusColor(data.value)">{{ statusLabel(data.value) }}</span>
            </template>
            <template #cell(invoice_pdf)="data">
                <a :href="data.item.invoice_pdf" class="btn btn-link p-0" v-if="data.item.invoice_pdf">Baixar</a>
            </template>
        </b-table>
    </b-card>
</template>

<script>
export default {
    
    props: {
        invoices: {
            default: []
        }
    },
    data() {
        return {
            fields: [
                { key: 'created_at', label: 'Data'},
                { key: 'total', label: 'Total'},
                { key: 'status', label: 'status'},
                { key: 'invoice_pdf', label: 'pdf'},
            ],

        }
    },
    created(){
        console.log(this.invoices);
    },
    methods: {
        statusLabel(status){
            switch (status)
            {
                case 'paid':
                    return 'Pago';
                case 'draft':
                    return 'Rascunho';
                case 'open':
                    return 'Aberto';
                case 'uncollectible':
                    return 'Incobrável';
                case 'void':
                    return 'Vazio';
            }
        },

        statusColor(status){
            switch (status)
            {
                case 'paid':
                    return 'success';
                case 'draft':
                    return 'info';
                case 'open':
                    return 'warning';
                case 'uncollectible':
                    return 'danger';
                case 'void':
                    return '';
            }
        }
    }
}
</script>

<style>

</style>